import { l } from '@manychat/manyui'

import { QuestionBlockReplyLabel } from 'common/builder/blocks/blockConstants'
import { IBlock, IQuestionBlock } from 'common/builder/blocks/blockInterfaces'
import { FlowChartNextStepBuilder } from 'common/builder/components/chart/FlowChart/lib/builders/FlowChartNextStepBuilder'
import {
  BlockConverterRulePayload,
  ConverterRule,
} from 'common/builder/components/chart/FlowChart/lib/types'
import { getButtonsFromMap } from 'common/builder/components/chart/FlowChart/lib/utils/getButtonsFromMap'
import { replaceFieldsInString } from 'common/builder/components/chart/FlowChart/lib/utils/replaceFieldsInString'
import * as sharedStyles from 'common/builder/components/chart/FlowChart/nodes/shared/styles'
import { FlowChartBlockType } from 'common/builder/components/chart/FlowChart/types/FlowChartBlock'
import { FlowChartUserInputBlock } from 'common/builder/components/chart/FlowChart/types/FlowChartUserInputBlock'
import { BlockType } from 'common/builder/constants/BlockType'

export const UserInputBlockGenericConverterRule: ConverterRule<
  IQuestionBlock,
  FlowChartUserInputBlock,
  BlockConverterRulePayload
> = {
  predicate: (entity: IBlock) => entity?.type === BlockType.FORM_QUESTION,
  convert: (entity: IQuestionBlock, { fields, flowChartButtons }) => ({
    id: entity.id,
    type: FlowChartBlockType.USER_INPUT,
    data: {
      question: entity.text ? replaceFieldsInString(entity.text, fields) : null,
      buttons: getButtonsFromMap(entity.buttons, flowChartButtons),
      nextStep: new FlowChartNextStepBuilder(entity.id)
        .withLabel(l.translate('Action on reply'))
        .withColor(sharedStyles.Colors.ACTIONS_CONNECTOR)
        .build(),
      fallbackNextStep: entity.blocks[0]
        ? new FlowChartNextStepBuilder(entity.blocks[0])
            .withLabel(l.translate('If contact has not responded'))
            .withColor(sharedStyles.Colors.DANGER)
            .build()
        : null,
      replyTypeLabel: QuestionBlockReplyLabel[entity.replyType]
        ? l.getString(QuestionBlockReplyLabel[entity.replyType])
        : null,
    },
  }),
}
